// extracted by mini-css-extract-plugin
export default {"root":"Updates_root__O8cEm","container":"Updates_container__uoOhy","list":"Updates_list__p2iJS","loader":"Updates_loader__zVwDI"};